module.exports = __webpack_public_path__ + "static/media/netlify.f44b55c7.svg";